const obj = {
  server: {
    api: "https://api-staging.warriortrading.com/api",
    stock: "https://scan-stage2.warriortrading.com",
    identity: "https://identity-stage.warriortrading.com/security",
    chatroom: "https://chatroom-stage.warriortrading.com",
    sim: "https://sim-stage.warriortrading.com",
  },
  scannerServers: [
    {
      name: "scan-qa",
      value: "https://scan-qa.warriortrading.com",
      down: "https://scan-qa.warriortrading.com/ops-api/v1/down-hpas",
      up: "https://scan-qa.warriortrading.com/ops-api/v1/up-hpas",
    },
    {
      name: "scan-stage2",
      value: "https://scan-stage2.warriortrading.com",
      down: "",
      up: "",
    },
  ],
};

export default obj;
